import {z} from "zod"

// per https://github.com/colinhacks/zod/issues/2461#issuecomment-1584276567
export const id = z.coerce.number().positive()
